import { AppMenuItem } from "../models/menu-config-utility"; 

export function filterMenuByRole(
  menus: AppMenuItem[],
  role: string
): AppMenuItem[] {
  return menus
    .filter(m => !m.roles || m.roles.includes(role))
    .map(m => ({
      ...m,
      children: m.children
        ? m.children.filter(c => !c.roles || c.roles.includes(role))
        : [],
    }));
}
